import React, { useEffect, useMemo, useState } from "react";
import { flattenCategories } from "../../utils/flattenCategories";
import { useExhibitorCategory } from "./hooks/useExhibitorCategory";
import { InputField, SelectField } from ".././FormFields";
export default function ExhibitorCategoryForm({
  initialData,
  onSubmit,
}) {
  const { data: categories, loadCategories } = useExhibitorCategory();

  const companyId = localStorage.getItem("company_id");

  const [form, setForm] = useState({
    name: "",
    parent_id: "",
  });

  useEffect(() => {
    if (companyId) {
      loadCategories(companyId);
    }
  }, [companyId]);

  useEffect(() => {
    if (initialData) {
      setForm({
        name: initialData.name || "",
        parent_id:
          initialData.parent_id?._id ||
          initialData.parent_id ||
          "",
      });
    }
  }, [initialData]);

  const parentCategories = useMemo(
    () => flattenCategories(categories || []),
    [categories]
  );

  const handleSubmit = (e) => {
    e.preventDefault();

     const payload = new FormData();
  payload.append("company_id", companyId);
  payload.append("name", form.name);

  if (form.parent_id) {
    payload.append("parent_id", form.parent_id);
  }

    onSubmit(payload);
  };

  return (
    <form onSubmit={handleSubmit} className="flex flex-col gap-3">
      <SelectField
        label="Parent Category"
        name="parent_id"
        value={form.parent_id || ""}
        onChange={(e) => setForm({ ...form, parent_id: e.target.value })}
        options={(parentCategories || []).map((item) => ({
          value: item._id,
          label: item.title,
        }))}
        placeholder="Search category..."
        isSearchable={true}
      />
      {/* <div>
        <label className="block text-sm mb-1">
          Parent Category
        </label>
        <select
          value={form.parent_id}
          onChange={(e) =>
            setForm({ ...form, parent_id: e.target.value })
          }
          className="w-full rounded border px-3 py-2"
        >
          <option value="">Parent Category (Optional)</option>
          {parentCategories.map((cat) => (
            <option key={cat._id} value={cat._id}>
              {cat.title}
            </option>
          ))}
        </select>
      </div> */}
      <InputField
        label="Category Name"
        name="title"
        value={form.name}
        onChange={(e) => setForm({ ...form, name: e.target.value })}
        required
      />
      {/* <div>
        <label className="block text-sm mb-1">
          Category Name<span className="text-red-500">*</span>
        </label>
        <input
          type="text"
          value={form.name}
          onChange={(e) =>
            setForm({ ...form, name: e.target.value })
          }
          className="w-full rounded border px-3 py-2"
          required
        />
      </div> */}

      <div className="mt-4 flex justify-end">
        <button
          type="submit"
          className="btn-primary"
        >
           {initialData ? "Update" : "Save"}
        </button>
      </div>
    </form>
  );
}
